import { xspocApiInstance } from "../api.ts";

export interface ConfigResponse {
  environmentType: string;
  authenticationType: string;
  appPath: string;
}

export interface ApplicationSettingsResponse {
  values: {
    ApplicationDeploymentMode: string;
    EnablePumpChecker: string;
    HostingEnvironment: string;
    appPath: string;
  };
  id: string;
  dateCreated: string;
}

// Fetch configuration data
const fetchConfigValueAsync = async (): Promise<ConfigResponse | null> => {
  try {
    const response = await xspocApiInstance.get<{ value: ConfigResponse }>(
      "EnvironmentType",
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );

    if (response && response.data && response.data.value) {
      return response.data.value;
    } else {
      console.log("No data found in response", response);
      return null;
    }
  } catch (error) {
    console.error("Error fetching configuration value", error);
    return null;
  }
};

export { fetchConfigValueAsync };
